import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

const VENDOR_PREFIXES = ['-webkit-', '-moz-', '-ms-', '-o-'];

const styles = theme => ({
	root: {
		position: 'sticky',
		top: 0,
		zIndex: theme.zIndex.stickyHeader,
		paddingTop: `${6 * theme.spacing.unit}px`,
		marginTop: `-${6 * theme.spacing.unit}px`,
		backgroundColor: theme.palette.common.white,
		'&:after': {
			content: '""',
			display: 'block',
			backgroundImage: 'radial-gradient(ellipse at 50% 0px, rgba(0, 0, 0, 0.06) 0%, transparent 75%)',
			backgroundPosition: '50% 0',
			backgroundSize: '150% 5px',
			backgroundRepeat: 'no-repeat',
			position: 'absolute',
			top: '100%',
			width: '100%',
			left: 0,
			right: 0,
			height: 24
		}
	}
});

@withStyles(styles)
class StickyHeader extends Component {

	render() {
		const { classes, className, children } = this.props;

		if (this.isStickyPositionSupported) {
			return (
				<div className={classNames(classes.root, className)}>
					{children}
				</div>
			);
		}

		return children;
	}

	get isStickyPositionSupported() {
		const test = window.document.head.style;

		for (const prefix of ['', ...VENDOR_PREFIXES]) {
			const position =`${prefix}sticky`;
			test.position = position;
			if (test.position === position) {
				return true;
			}
		}

		return false;
	}
}

StickyHeader.propTypes = {
	children: PropTypes.node,
	classes: PropTypes.object,
	className: PropTypes.string
};

export default StickyHeader;


// WEBPACK FOOTER //
// ./src/components/StickyHeader/StickyHeader.js